import axios from "axios";
import { BaseURL } from "../Helper/config";
import { ErrorToast } from "../Helper/FormHelper";
import {
  getSellerFood,
  getSellerInfo,
  setLimitedSellerList,
} from "../Redux/State-slice/SellerSlice";
import store from "../Redux/Store/Store";

export const GetLimitedSellerAPI = async (limit) => {
  try {
    let URL = `${BaseURL}/get-become-seller/${limit}`;
    let res = await axios.get(URL);

    if (res.status === 200 && res.data["status"] === "Success") {
      store.dispatch(setLimitedSellerList(res.data.data));
      return true;
    } else {
      ErrorToast("Something wrong! GetAllCategoryAPI -1");
      return false;
    }
  } catch (e) {
    ErrorToast("Something wrong! GetAllCategoryAPI -2");
    return false;
  }
};
export const GetSellerAPI = async (id) => {
  try {
    let URL = `${BaseURL}/get-single-become-seller/${id}`;
    let res = await axios.get(URL);

    if (res.status === 200 && res.data["status"] === "Success") {
      store.dispatch(getSellerInfo(res.data.data));
      return true;
    } else {
      ErrorToast("Something wrong! GetAllCategoryAPI -1");
      return false;
    }
  } catch (e) {
    ErrorToast("Something wrong! GetAllCategoryAPI -2");
    return false;
  }
};
export const GetFoodBySellerAPI = async (id) => {
  try {
    let URL = `${BaseURL}/get-food-by-seller/${id}`;
    let res = await axios.get(URL);

    if (res.status === 200 && res.data["status"] === "Success") {
      console.log("food list", res);
      store.dispatch(getSellerFood(res?.data?.metaData));
      return true;
    } else {
      ErrorToast("Something wrong! GetFoodBySellerAPI -1");
      return false;
    }
  } catch (e) {
    ErrorToast("Something wrong! GetFoodBySellerAPI -1");
    return false;
  }
};